import { render, staticRenderFns } from "./similar.vue?vue&type=template&id=4e6cac19&scoped=true&"
import script from "./similar.vue?vue&type=script&lang=js&"
export * from "./similar.vue?vue&type=script&lang=js&"
import style0 from "./similar.vue?vue&type=style&index=0&id=4e6cac19&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6cac19",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SimilarWare: require('/app/components/similarWare/similarWare.vue').default})
